import { BaseModel } from '../base-model'
import { BaseModelData } from '../base-model-data'
import { Clinician } from '../clinician'
import { PatientInsurance } from '../patient-insurance/patient-insurance.model'

export interface HistoryMessageData {
  patientInsurance?: PatientInsurance
  updatedValues?: HistoryMessageUpdatedValues
}

export interface HistoryMessageUpdatedValues {
  [key: string]: {
    oldValue: string | string[] | number
    newValue: string | string[] | number
  }
}

export interface PatientInsuranceHistoryData extends BaseModelData {
  actor: {
    clinician?: Clinician
    type: 'clinician' | 'patientpal'
  }
  appointmentId?: string
  insuranceId?: string
  type: string
  level: number
  message: string
  messageData: HistoryMessageData
}

export class PatientInsuranceHistoryModel extends BaseModel {
  id: string
  actor: {
    clinician?: Clinician
    type: 'clinician' | 'patientpal'
  }
  appointmentId?: string
  insuranceId?: string
  clinicId: string
  type: string
  level: number
  message: string
  messageData: HistoryMessageData

  static visibleUpdatedValueKeys = [
    'status',
    'eligibilityStatus',
    'memberId',
    'effectiveFrom',
    'effectiveTo',
    // 'authorizationStatus',
    // 'clearanceStatus',
    // 'eligibilityId',
  ]

  constructor(data: PatientInsuranceHistoryData) {
    super(data, true)

    if (data.messageData?.updatedValues) {
      const updatedValues = data.messageData.updatedValues
      data.messageData.updatedValues = Object.keys(updatedValues).reduce((result, key) => {
        if (PatientInsuranceHistoryModel.visibleUpdatedValueKeys.includes(key)) {
          return {
            ...result,
            [key]: updatedValues[key],
          }
        }

        return result
      }, {})
    }
  }

  public get actorName(): string {
    if (this.actor.type === 'clinician' && this.actor.clinician) {
      return this.actor.clinician.name
    } else if (this.actor.type === 'patientpal') {
      return 'System'
    } else {
      return 'Unknown Actor'
    }
  }
}
